import * as FilterInsightStatus from '../../filterQueryFormat/FilterInsightStatus';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useMemo } from 'react';
import FilterInsightStatusIcon from './FilterInsightStatusIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerFilterInsightDisplay = props => {
  const {
    objectName,
    pluralizedObjectName,
    filterInsight,
    isRollup
  } = props;
  const {
    matchedRecords,
    percentageOfRecordsMatched
  } = filterInsight;
  const objectType = matchedRecords && matchedRecords === 1 ? objectName : pluralizedObjectName;
  const options = {
    objectType,
    lowercaseObjectType: objectType.toLocaleLowerCase(),
    matchedRecords,
    percentageOfRecordsMatched
  };
  const status = useMemo(() => {
    if (matchedRecords && matchedRecords > 0) {
      return FilterInsightStatus.SOME;
    }
    return FilterInsightStatus.NONE;
  }, [matchedRecords]);
  const message = useMemo(() => {
    if (typeof percentageOfRecordsMatched === 'number') {
      return isRollup ? 'customerDataFiltersUI.filterInsights.rollupWithPercentage' : 'customerDataFiltersUI.filterInsights.withPercentage';
    }
    return isRollup ? 'customerDataFiltersUI.filterInsights.rollupWithoutPercentage' : 'customerDataFiltersUI.filterInsights.withoutPercentage';
  }, [percentageOfRecordsMatched, isRollup]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    as: "div",
    children: [/*#__PURE__*/_jsx(FilterInsightStatusIcon, {
      filterInsightStatus: status
    }), /*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message,
        options: options
      })
    })]
  });
};
export default ViewerFilterInsightDisplay;